/**
 * SovereigntyBanner — the emerald trust ribbon used across every
 * public-facing entrypoint (EcosystemGateway hero, Login, Signup,
 * Pricing, Security, Modules). Click → /security.
 *
 * Props:
 *   size  'sm' | 'md' (default 'md')
 *   className  extra classes for layout (e.g. centering on Login)
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { t, isRtl } from '@/lib/i18nNav';

export default function SovereigntyBanner({ size = 'md', className = '' }) {
  const isSm = size === 'sm';
  const rtl = isRtl();
  return (
    <Link
      to="/security"
      data-testid="sovereignty-banner"
      dir={rtl ? 'rtl' : 'ltr'}
      className={`group inline-flex items-center gap-3 ${isSm ? 'px-3 py-2' : 'px-4 py-3'} rounded-lg border border-emerald-400/30 bg-emerald-500/5 hover:bg-emerald-500/10 transition-colors ${className}`}
    >
      <span className="relative inline-flex h-2 w-2 shrink-0">
        <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-70" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
      </span>
      <div className={`min-w-0 ${rtl ? 'text-right' : 'text-left'}`}>
        <div className={`uppercase tracking-[0.22em] font-bold text-emerald-600 dark:text-emerald-300 ${isSm ? 'text-[9px]' : 'text-[10px]'} ${rtl ? 'tracking-normal' : ''}`}>
          {t('sov.eyebrow')}
        </div>
        <div className={`${isSm ? 'text-[11px]' : 'text-[12px]'} text-slate-700 dark:text-white/80 mt-0.5 max-w-md leading-relaxed`}>
          {t('sov.body')}
        </div>
      </div>
      <ArrowRight size={isSm ? 12 : 14} className={`text-emerald-600 dark:text-emerald-300 shrink-0 ${rtl ? 'rotate-180 group-hover:-translate-x-1' : 'group-hover:translate-x-1'} transition-transform`} />
    </Link>
  );
}
